import { DatSelectionSteps } from "../../../data/enums"
import { NavigationState } from "./model"

export const DEFAULT_STATE: NavigationState = {
    active: DatSelectionSteps.NONE,
    params: {},
}
